import React from "react";

import EmptyTableData from "components/common/empty_data/EmptyTableData";
import LoadingModal from "components/common/loading/LoadingModal";
import ArchivedReportTableToolbar from "./components/ArchivedReportTableToolbar";
import useArchivedReportTableColumns from "./hooks/useArchivedReportTableColumn";

import { DEFAULT_LARGE_PAGE_SIZE_OPTIONS } from "static/pagination";
import CustomTable from "components/common/table/CustomTable";

const ArchivedReportTable = ({
  isLoading,
  data,
  pagination,
  sorting,
  setPagination,
  setSorting,
  reports,
  downloadReports,
  isDownloading,
  isDownloadingBulkReports,
}) => {
  const { columns } = useArchivedReportTableColumns();

  return (
    <>
      <CustomTable
        columns={columns}
        data={data?.data || []}
        options={{
          rowCount: data?.meta?.total || 0,
          state: {
            isLoading: isLoading,
            pagination,
            sorting,
          },
          // layoutMode: "grid-no-grow",
          manualPagination: true,
          onPaginationChange: setPagination,
          onSortingChange: setSorting,
          rowsPerPageOptions: DEFAULT_LARGE_PAGE_SIZE_OPTIONS,
          renderEmptyRowsFallback: () => (
            <EmptyTableData
              title="No Reports Found"
              content={
                <p>
                  No archived reports match the selected filters. <br /> Try
                  adjusting the date range, account, or report criteria above.
                </p>
              }
              contentStyle={{ maxWidth: "450px" }}
            />
          ),
          enableTopToolbar: true,
          renderTopToolbar: () => (
            <ArchivedReportTableToolbar
              reports={reports}
              downloadReports={downloadReports}
            />
          ),
          muiTableBodyRowProps: ({ row }) => ({
            onClick: () => {
              const href = `/patient/report/${row?.original?._id}`;
              var a = document.createElement("a");
              a.href = href;
              a.setAttribute("target", "_blank");
              a.click();
            },
            sx: {
              cursor: "pointer",
            },
          }),
        }}
        localization={{
          toolbar: { searchPlaceholder: "Search Patient" },
          body: { emptyDataSourceMessage: <EmptyTableData /> },
        }}
        style={{
          border: "1px solid #e0e0e0",
          boxShadow: "none",
        }}
      />
      {(isDownloading || isDownloadingBulkReports) && (
        <LoadingModal
          open={isDownloading || isDownloadingBulkReports}
          loadingText="Downloading..."
        />
      )}
    </>
  );
};

export default ArchivedReportTable;
